import React, { useEffect } from 'react';
import './../App.css';
import PageShell from '../components/layout/PageShell';
import PageHeader from '../components/layout/PageHeader';

const ContactPage = () => {
    useEffect(() => {
        document.title = 'animix - Контакты';
    }, []);

    return (
        <PageShell narrow className="info-page">
            <PageHeader
                title="Контакты"
                lead="Для сотрудничества, выяснения спорных вопросов или претензий направляйте электронное письмо."
            />
            <a className="contact-email" href="mailto:obdristaev@gmail.com">obdristaev@gmail.com</a>
        </PageShell>
    );
};

export default ContactPage;
